import LocationPageTemplate from '../components/LocationPageTemplate';
export default function AnnapolisPage() { return <LocationPageTemplate locationSlug="annapolis" />; }
